var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row form-group"},[_c('zahlungseingang-zuweisen-modal',{attrs:{"id":"zahlungseingang-zuweisen-modal","betrag":_vm.betrag},on:{"confirmed":_vm.onDebitorResult}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }